/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FBatchInvoiceAmountUpdateSchema } from '../models/FBatchInvoiceAmountUpdateSchema';
import type { FBatchInvoiceDetailSchema } from '../models/FBatchInvoiceDetailSchema';
import type { FTTicketListSchema } from '../models/FTTicketListSchema';
import type { KBatchCorrectiveCreateSchema } from '../models/KBatchCorrectiveCreateSchema';
import type { KBatchDetailSchema } from '../models/KBatchDetailSchema';
import type { KBatchOriginalCreateSchema } from '../models/KBatchOriginalCreateSchema';
import type { KbatchPurobotUploadSchema } from '../models/KbatchPurobotUploadSchema';
import type { KBatchType } from '../models/KBatchType';
import type { PagedKBatchDocumentListSchema } from '../models/PagedKBatchDocumentListSchema';
import type { PagedKBatchListSchema } from '../models/PagedKBatchListSchema';
import type { PagedPortalZpSubmissionListSchema } from '../models/PagedPortalZpSubmissionListSchema';
import type { PortalZpBatchSignaturesSubmitSchema } from '../models/PortalZpBatchSignaturesSubmitSchema';
import type { PortalZpBatchSubmissionCreateSchema } from '../models/PortalZpBatchSubmissionCreateSchema';
import type { PortalZpBatchSubmissionDetailSchema } from '../models/PortalZpBatchSubmissionDetailSchema';
import type { PortalZpBatchSubmissionQueuedSchema } from '../models/PortalZpBatchSubmissionQueuedSchema';
import type { PortalZpSmsAuthSubmitSchema } from '../models/PortalZpSmsAuthSubmitSchema';
import type { PortalZpSmsCodeRequestSchema } from '../models/PortalZpSmsCodeRequestSchema';
import type { PortalZpSmsCodeSentSchema } from '../models/PortalZpSmsCodeSentSchema';
import type { PortalZpSubmissionDetailSchema } from '../models/PortalZpSubmissionDetailSchema';
import type { SignSubmitSchema } from '../models/SignSubmitSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class KBatchesApi {
    /**
     * Get K Batch List
     * Get k-batch list. <br>Required permission: get_k_batch_list
     * @returns PagedKBatchListSchema OK
     * @throws ApiError
     */
    public static insuranceGetKBatchListGet({
        periodStartDate,
        periodEndDate,
        insuranceCompanyCodes,
        batchType,
        companyInsuranceWorkspaceIds,
        search,
        ordering,
        limit = 100,
        offset,
    }: {
        periodStartDate?: (string | null),
        periodEndDate?: (string | null),
        insuranceCompanyCodes?: (Array<string> | null),
        batchType?: (KBatchType | null),
        companyInsuranceWorkspaceIds?: (Array<string> | null),
        search?: (string | null),
        ordering?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedKBatchListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/k-batches/',
            query: {
                'period_start_date': periodStartDate,
                'period_end_date': periodEndDate,
                'insurance_company_codes': insuranceCompanyCodes,
                'batch_type': batchType,
                'company_insurance_workspace_ids': companyInsuranceWorkspaceIds,
                'search': search,
                'ordering': ordering,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Original K Batches
     * Create original k-batches. <br>Required permission: create_k_batch
     * @returns KBatchDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreateOriginalKBatchesPost({
        requestBody,
    }: {
        requestBody: KBatchOriginalCreateSchema,
    }): CancelablePromise<Array<KBatchDetailSchema>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/k-batches/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upload K Batches To Purobot
     * Uploads batches to purobot
     * @returns void
     * @throws ApiError
     */
    public static insuranceUploadKBatchesToPurobotPost({
        requestBody,
    }: {
        requestBody: KbatchPurobotUploadSchema,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/k-batches/purobot/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Portal Zp Batch Submission
     * Build one Portál ZP submission per selected batch and return the bytes to sign. All or nothing: one invalid batch rejects the whole request. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpBatchSubmissionDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreatePortalZpBatchSubmissionPost({
        requestBody,
    }: {
        requestBody: PortalZpBatchSubmissionCreateSchema,
    }): CancelablePromise<PortalZpBatchSubmissionDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/k-batches/portal-zp-batch-submissions/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Portal Zp Batch Signatures
     * Attach one signature per submission, all produced by the same certificate, and queue the group for delivery. The outcome arrives by e-mail. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpBatchSubmissionQueuedSchema Accepted
     * @throws ApiError
     */
    public static insuranceSetPortalZpBatchSignaturesPut({
        batchSubmissionId,
        requestBody,
    }: {
        batchSubmissionId: string,
        requestBody: PortalZpBatchSignaturesSubmitSchema,
    }): CancelablePromise<PortalZpBatchSubmissionQueuedSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/k-batches/portal-zp-batch-submissions/{batch_submission_id}/signatures/',
            path: {
                'batch_submission_id': batchSubmissionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Portal Zp Batch Sms Code
     * Authorise every submission in the group with one SMS code and queue the group for delivery. The first submission is sent at once to test the code; a refused code answers 422 and leaves the group awaiting. The outcome arrives by e-mail. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpBatchSubmissionQueuedSchema Accepted
     * @throws ApiError
     */
    public static insuranceSetPortalZpBatchSmsCodePut({
        batchSubmissionId,
        requestBody,
    }: {
        batchSubmissionId: string,
        requestBody: PortalZpSmsAuthSubmitSchema,
    }): CancelablePromise<PortalZpBatchSubmissionQueuedSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/k-batches/portal-zp-batch-submissions/{batch_submission_id}/sms-code/',
            path: {
                'batch_submission_id': batchSubmissionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Portal Zp Batch Password Auth
     * Verify the stored ZP MV ČR credentials with one login and queue the group for delivery. Nothing is sent before the group is queued; a refused login answers 422 and leaves the group awaiting. The outcome arrives by e-mail. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpBatchSubmissionQueuedSchema Accepted
     * @throws ApiError
     */
    public static insuranceSetPortalZpBatchPasswordAuthPut({
        batchSubmissionId,
    }: {
        batchSubmissionId: string,
    }): CancelablePromise<PortalZpBatchSubmissionQueuedSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/k-batches/portal-zp-batch-submissions/{batch_submission_id}/password-auth/',
            path: {
                'batch_submission_id': batchSubmissionId,
            },
        });
    }
    /**
     * Request Portal Zp Sms Code
     * Have the portal text a login code to the phone of the user's portal account, using the credentials stored under /users/me/portal-zp-credentials/ (422 when there are none). The code is valid on every gateway of the portal for the time the portal states. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpSmsCodeSentSchema Created
     * @throws ApiError
     */
    public static insuranceRequestPortalZpSmsCodePost({
        requestBody,
    }: {
        requestBody: PortalZpSmsCodeRequestSchema,
    }): CancelablePromise<PortalZpSmsCodeSentSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/k-batches/portal-zp-sms-codes/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get K Batch Detail
     * Get k-batch detail. <br>Required permission: get_k_batch_detail
     * @returns KBatchDetailSchema OK
     * @throws ApiError
     */
    public static insuranceGetKBatchDetailGet({
        kBatchId,
    }: {
        kBatchId: string,
    }): CancelablePromise<KBatchDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/k-batches/{k_batch_id}/',
            path: {
                'k_batch_id': kBatchId,
            },
        });
    }
    /**
     * Delete K Batch
     * Delete k-batch.
     * - Please note, that related f-batch-invoice and all k-batch-documents will also be deleted.
     * - Required permission: remove_k_batch
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeleteKBatchDelete({
        kBatchId,
    }: {
        kBatchId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/k-batches/{k_batch_id}/',
            path: {
                'k_batch_id': kBatchId,
            },
        });
    }
    /**
     * Get K Batch Zip
     * Download k-batch and its f-batch invoice files as a ZIP archive. <br>Required permission: get_k_batch_detail
     * @returns any OK
     * @throws ApiError
     */
    public static insuranceGetKBatchZipGet({
        kBatchId,
    }: {
        kBatchId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/k-batches/{k_batch_id}/zip/',
            path: {
                'k_batch_id': kBatchId,
            },
        });
    }
    /**
     * Set F Batch Invoice Amount
     * Switch the batch invoice amount between the contract flat rate sum and the price of the batch actions and regenerate its FDAVKA file. The invoice keeps the flat-rate format. Only invoices with `can_use_actions_amount` can be switched to the actions amount; a batch with an in-progress Portál ZP submission cannot be changed. <br>Required permission: create_k_batch
     * @returns FBatchInvoiceDetailSchema OK
     * @throws ApiError
     */
    public static insuranceSetFBatchInvoiceAmountPut({
        kBatchId,
        invoiceId,
        requestBody,
    }: {
        kBatchId: string,
        invoiceId: string,
        requestBody: FBatchInvoiceAmountUpdateSchema,
    }): CancelablePromise<FBatchInvoiceDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/k-batches/{k_batch_id}/invoices/{invoice_id}/amount/',
            path: {
                'k_batch_id': kBatchId,
                'invoice_id': invoiceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Corrective K Batch
     * Create corrective k-batch from k-batch. <br>Required permission: create_k_batch
     * @returns KBatchDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreateCorrectiveKBatchPost({
        kBatchId,
        requestBody,
    }: {
        kBatchId: string,
        requestBody: KBatchCorrectiveCreateSchema,
    }): CancelablePromise<KBatchDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/k-batches/{k_batch_id}/corrective-batch/',
            path: {
                'k_batch_id': kBatchId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Ft Tickets For Corrective K Batch
     * Create corrective k-batch from k-batch. <br>Required permission: create_k_batch
     * @returns FTTicketListSchema OK
     * @throws ApiError
     */
    public static insuranceGetFtTicketsForCorrectiveKBatchGet({
        kBatchId,
        periodStartDate,
        periodEndDate,
        companyInsuranceWorkspaceIds,
        search,
    }: {
        kBatchId: string,
        periodStartDate: string,
        periodEndDate: string,
        companyInsuranceWorkspaceIds: Array<string>,
        search?: (string | null),
    }): CancelablePromise<Array<FTTicketListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/k-batches/{k_batch_id}/corrective-batch/ft-tickets/',
            path: {
                'k_batch_id': kBatchId,
            },
            query: {
                'period_start_date': periodStartDate,
                'period_end_date': periodEndDate,
                'company_insurance_workspace_ids': companyInsuranceWorkspaceIds,
                'search': search,
            },
        });
    }
    /**
     * Get K Batch Document List
     * Get k-batch documents for k-batch. <br>Required permission: get_k_batch_document_list
     * @returns PagedKBatchDocumentListSchema OK
     * @throws ApiError
     */
    public static insuranceGetKBatchDocumentListGet({
        kBatchId,
        search,
        ordering,
        limit = 100,
        offset,
    }: {
        kBatchId: string,
        search?: (string | null),
        ordering?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedKBatchDocumentListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/k-batches/{k_batch_id}/k-batch-documents/',
            path: {
                'k_batch_id': kBatchId,
            },
            query: {
                'search': search,
                'ordering': ordering,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Portal Zp Submission
     * Build a Portál ZP submission for a batch and return the bytes to sign. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpSubmissionDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreatePortalZpSubmissionPost({
        kBatchId,
    }: {
        kBatchId: string,
    }): CancelablePromise<PortalZpSubmissionDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/k-batches/{k_batch_id}/portal-zp-submissions/',
            path: {
                'k_batch_id': kBatchId,
            },
        });
    }
    /**
     * Get Portal Zp Submission List
     * List Portál ZP submissions of a batch. <br>Required permission: get_portal_zp_submission
     * @returns PagedPortalZpSubmissionListSchema OK
     * @throws ApiError
     */
    public static insuranceGetPortalZpSubmissionListGet({
        kBatchId,
        limit = 100,
        offset,
    }: {
        kBatchId: string,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedPortalZpSubmissionListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/k-batches/{k_batch_id}/portal-zp-submissions/',
            path: {
                'k_batch_id': kBatchId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Portal Zp Submission
     * Get one Portál ZP submission. <br>Required permission: get_portal_zp_submission
     * @returns PortalZpSubmissionDetailSchema OK
     * @throws ApiError
     */
    public static insuranceGetPortalZpSubmissionGet({
        kBatchId,
        submissionId,
    }: {
        kBatchId: string,
        submissionId: string,
    }): CancelablePromise<PortalZpSubmissionDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/k-batches/{k_batch_id}/portal-zp-submissions/{submission_id}/',
            path: {
                'k_batch_id': kBatchId,
                'submission_id': submissionId,
            },
        });
    }
    /**
     * Delete Portal Zp Submission
     * Delete a submission that still awaits authorization, e.g. to regenerate the invoice and create a new one. Any other status answers 422. A submission of a bulk group can be deleted too; the group then has to be signed without it, and is removed with its last submission. <br>Required permission: create_portal_zp_submission
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeletePortalZpSubmissionDelete({
        kBatchId,
        submissionId,
    }: {
        kBatchId: string,
        submissionId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/k-batches/{k_batch_id}/portal-zp-submissions/{submission_id}/',
            path: {
                'k_batch_id': kBatchId,
                'submission_id': submissionId,
            },
        });
    }
    /**
     * Set Portal Zp Signature
     * Attach the client-produced signature and hand the submission to the insurer's gateway. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpSubmissionDetailSchema OK
     * @throws ApiError
     */
    public static insuranceSetPortalZpSignaturePut({
        kBatchId,
        submissionId,
        requestBody,
    }: {
        kBatchId: string,
        submissionId: string,
        requestBody: SignSubmitSchema,
    }): CancelablePromise<PortalZpSubmissionDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/k-batches/{k_batch_id}/portal-zp-submissions/{submission_id}/signature/',
            path: {
                'k_batch_id': kBatchId,
                'submission_id': submissionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Portal Zp Sms Code
     * Authorise the submission with an SMS code instead of a signature and hand it to the insurer's gateway. A refused code answers 422 and leaves the submission awaiting. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpSubmissionDetailSchema OK
     * @throws ApiError
     */
    public static insuranceSetPortalZpSmsCodePut({
        kBatchId,
        submissionId,
        requestBody,
    }: {
        kBatchId: string,
        submissionId: string,
        requestBody: PortalZpSmsAuthSubmitSchema,
    }): CancelablePromise<PortalZpSubmissionDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/k-batches/{k_batch_id}/portal-zp-submissions/{submission_id}/sms-code/',
            path: {
                'k_batch_id': kBatchId,
                'submission_id': submissionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Portal Zp Password Auth
     * Log in to the insurer's gateway with the credentials stored under /users/me/portal-zp-credentials/ and hand the submission over (ZP MV ČR). A refused login answers 422 and leaves the submission awaiting. <br>Required permission: create_portal_zp_submission
     * @returns PortalZpSubmissionDetailSchema OK
     * @throws ApiError
     */
    public static insuranceSetPortalZpPasswordAuthPut({
        kBatchId,
        submissionId,
    }: {
        kBatchId: string,
        submissionId: string,
    }): CancelablePromise<PortalZpSubmissionDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/k-batches/{k_batch_id}/portal-zp-submissions/{submission_id}/password-auth/',
            path: {
                'k_batch_id': kBatchId,
                'submission_id': submissionId,
            },
        });
    }
}
